<template>
  <div class="home">
    <Navbar/>
    <!-- BANNER -->
    <div class="banner-home">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col text-center">
            <a href="http://www.editoradobrasil.com.br/faleconosco/" target="_blank" class="btn-duvidas" rel="noopener noreferrer">DÚVIDAS ? FALE CONOSCO</a>
          </div>
        </div>
        <div class="row justify-content-center btns-banner menu-md">
          <div class="col-md-10">
            <div class="row">
              <div class="col-md-6 text-center p-0">
                <router-link class="btn btn-branco" to="/anos-iniciais">Ensino Fundamental - Anos Iniciais</router-link>
              </div>
              <div class="col-md-6 text-center p-0">
                <router-link class="btn btn-branco2" to="/anos-finais">Ensino Fundamental - Anos Finais</router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-md-9 p-0">
            <div class="text-banner">
              A coleção foca no equilíbrio financeiro e orienta o aluno a utilizar o dinheiro de forma consciente, o que mais tarde, o auxiliará na conquista de seus sonhos futuros.
            </div>
          </div>
        </div>
        <div class="row justify-content-center btns-banner menu-sm">
          <div class="col-md-10">
            <div class="row">
              <div class="col-md-6 text-center p-0">
                <router-link class="btn btn-branco" to="/anos-iniciais">Ensino Fundamental - Anos Iniciais</router-link>
              </div>
              <div class="col-md-6 text-center p-0">
                <router-link class="btn btn-branco2" to="/anos-finais">Ensino Fundamental - Anos Finais</router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center carousel-home">
          <div class="col-md-11">
            <VueSlickCarousel v-bind="settings">
              <div class="">
                <a href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/educacao-financeira/1/index.html" target="_blank" rel="noopener noreferrer"><img src="../assets/livros/fin1.png" class="img-fluid mx-auto"></a>
              </div>
              <div class="">
                <a href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/educacao-financeira/2/index.html" target="_blank" rel="noopener noreferrer"><img src="../assets/livros/fin2.png" class="img-fluid mx-auto"></a>
              </div>
              <div class="">
                <a href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/educacao-financeira/3/index.html" target="_blank" rel="noopener noreferrer"><img src="../assets/livros/fin3.png" class="img-fluid mx-auto"></a>
              </div>
              <div class="">
                <a href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/educacao-financeira/4/index.html" target="_blank" rel="noopener noreferrer"><img src="../assets/livros/fin4.png" class="img-fluid mx-auto"></a>
              </div>
              <div class="">
                <a href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/educacao-financeira/5/index.html" target="_blank" rel="noopener noreferrer"><img src="../assets/livros/fin5.png" class="img-fluid mx-auto"></a>
              </div>
              <div class="">
                <a href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/educacao-financeira/vu/index.html" target="_blank" rel="noopener noreferrer"><img src="../assets/livros/fin0.png" class="img-fluid mx-auto"></a>
              </div>
            </VueSlickCarousel>
          </div>
        </div>
      </div>
    </div>
    <!-- CONTEUDO DIGITAL -->
    <div class="container conteudo">
      <div class="row justify-content-center">
        <div class="col-md-10 text-center">
          <h1>Todo conteúdo digital em um só lugar</h1>
          <p>A Coleção tem conteúdos e ferramentas digitais disponíveis no Laboratório Educacional Brasil (LEB), um ambiente virtual especialmente elaborado para proporcionar uma experiência dinâmica e transformadora com o conhecimento.</p>
          <img src="../assets/logos/logo-leb.png" class="img-fluid mx-auto">
        </div>
      </div>
    </div>
    <!-- PRINCIPAIS -->
    <div class="container principais">
      <div class="row justify-content-center">
        <div class="col-md-10 text-center">
          <h1>Principais recursos digitais<br>para aluno e Professor</h1>
          <p>Materiais alinhados à Base Nacional Comum Curricular (BNCC) e ferramentas digitais que colaboram com o processo de aprendizagem em sala de aula.</p>
          <img src="../assets/logos/bncc.png" class="img-fluid mx-auto">
        </div>
      </div>
    </div>
    <!-- RECURSOS DIGITAIS -->
    <div class="container recursos-digitais">
      <div class="row">
        <div class="col-md-12 text-center">
          <h1>Recursos Digitais</h1>
        </div>
        <div class="col-md-11 offset-md-1">
          <h2><img src="../assets/icons/icon-recursos.png" class="img-fluid tick"> Professor</h2>
        </div>
        <div class="col-md-5 offset-md-1 hide-sm">
          <img src="../assets/imagens/recursos/professor.png" class="img-fluid">
        </div>
        <div class="col-md-5">
          <div class="box">
            <div class="lista">
              <ul class="list-unstyled">
                <li>Audiovisuais</li>
                <li>Banco de Questões</li>
                <li>Sequências didáticas</li>
                <li>Isto pode virar aula</li>
                <li>Jogos</li>
                <li>Livros Digitais</li>
                <li>Planejador de aulas</li>
              </ul>
            </div>
            <a href="https://www.editoradobrasil.com.br/leb" target="_blank">Acessar a plataforma <img src="../assets/icons/Icon feather-mouse-pointer.png" class="img-fluid"></a>
          </div>
        </div>
        <div class="col-md-11 offset-md-1">
          <h2><img src="../assets/icons/icon-recursos.png" class="img-fluid tick"> Aluno</h2>
        </div>
        <div class="col-md-5 offset-md-1 hide-sm">
          <img src="../assets/imagens/recursos/aluno.png" class="img-fluid">
        </div>
        <div class="col-md-5">
          <div class="box">
            <div class="lista">
              <ul class="list-unstyled">
                <li>Audiovisuais</li>
                <li>Livros Digitais</li>
                <li>Jogos</li>
              </ul>
            </div>
            <a href="https://www.editoradobrasil.com.br/leb" target="_blank">Acessar a plataforma <img src="../assets/icons/Icon feather-mouse-pointer.png" class="img-fluid"></a>
          </div>
        </div>
        <div class="col-md-12 col-8 offset-2 offset-md-0 text-center">
          <h3>e muito mais.</h3>
          <p>Confira os recursos que contemplam a sua obra.</p>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
  name: 'Home',
  components: {
    Navbar,
    Footer,
    VueSlickCarousel
  },
  data() {
    return {
      settings: {
          "arrows": true,
          "slidesToShow": 4,
          "slidesToScroll": 1,
          "initialSlide": 0,
          "touchMove": false,
          "responsive": [
              {
              "breakpoint": 1024,
              "settings": {
                  "slidesToShow": 4,
                  "slidesToScroll": 1
                  }
              },
              {
              "breakpoint": 600,
              "settings": {
                  "slidesToShow": 2,
                  "slidesToScroll": 1,
                  "centerMode": true,
                  "touchMove": true,
                  "variableWidth": true
                  }
              },
              {
              "breakpoint": 480,
              "settings": {
                  "slidesToShow": 1,
                  "slidesToScroll": 1,
                  "centerMode": true,
                  "touchMove": true,
                  "variableWidth": true
                  }
              }
          ]
      }
    }
  }
}
</script>
